export const globalActionsQueryKeys = {
  all: ["orchestratorGlobalActions"] as const,
  lists: () => [...globalActionsQueryKeys.all, "list"] as const,
  list: (propertyTicker: string) =>
    [...globalActionsQueryKeys.lists(), { propertyTicker }] as const,
  details: () => [...globalActionsQueryKeys.all, "detail"] as const,
  detail: (propertyTicker: string, id: string) =>
    [...globalActionsQueryKeys.details(), propertyTicker, id] as const,
};
